<div class="card" *ngIf="subscriber">
  <div class="card-header" [ngClass]="cardHeaderClass">
    <a
      type="button"
      [routerLink]="'/users/subscribers/' + subscriber.subscriberId"
    >
      {{ subscriber.subscriberId }} - {{ subscriber.boxId || 'SEM ID' }}
    </a>
  </div>
  <div class="card-body">
    <p class="description">
      <strong>Assinatura</strong>:
      {{ subscriber.subscriptionName | titlecase }}
      <i
        *ngIf="[2, 8, 9].includes(subscriber.subscriptionId)"
        class="pi pi-crown"
        style="color: gold; font-weight: 700"
        pTooltip="Assinatura Premium"
        tooltipPosition="bottom"
      ></i>
    </p>
    <p class="description">
      <strong>Plano</strong>:
      {{ subscriber.subscriptionTypeName }}
    </p>
    <p class="description">
      <strong>Edição de início</strong>:
      {{ editionAsDate | date: 'MMMM/yyyy' : '' : 'pt-BR' | titlecase }}
    </p>
    <p class="description">
      <strong>Fim do ciclo</strong>:
      <ng-container *ngIf="!endOfCycleDate">Indefinido</ng-container>
      <ng-container *ngIf="endOfCycleDate">
        {{ endOfCycleDate | date: 'MMMM/yyyy' : '' : 'pt-BR' | titlecase }}
      </ng-container>
    </p>
    <p class="description">
      <strong>Valor</strong>:
      {{ subscriber.subscriptionPrice | currency: 'BRL' }}
    </p>
    <p class="description">
      <strong>Forma de pagamento</strong>:
      {{ paymentMethod }}
    </p>
    <p class="description">
      <strong>Status</strong>:
      <span
        class="status"
        [class.status--active]="subscriber.subscriberStatus === 0"
        [class.status--warning]="
          [10, 11, 12].includes(subscriber.subscriberStatus)
        "
      >
        {{ subscriber.status }}
      </span>
    </p>
  </div>
  <div class="card-footer"></div>
</div>
